import React from 'react';

/* Profile → Change Password tab: 3 password rows (right-aligned labels) + notes + submit. */
export default function ChangePassword() {
  const Row = ({ id, label }) => (
    <div className="row mb-lg-3 mt-lg-2 align-items-center">
      <label htmlFor={id} className="col-md-3 col-lg-3 col-form-label text-lg-end">{label} :</label>
      <div className="col-md-9 col-lg-9">
        <input type="password" id={id} className="form-control" autoComplete="new-password" />
      </div>
    </div>
  );
  return (
    <div className="app-change-password">
      <form className="cp_form" noValidate onSubmit={(e) => e.preventDefault()}>
        <Row id="currentPassword" label="Current Password" />
        <Row id="newPassword" label="New Password" />
        <Row id="renewPassword" label="Re-enter New Password" />
        <div className="feedback">
          <p className="small m-0"><i><b>Note:</b> The New Password field must be at least 6 characters</i></p>
          <p className="small m-0"><i>The New Password must contain at least: 1 uppercase letter, 1 lowercase letter, 1 number</i></p>
        </div>
        <div className="row">
          <button type="submit" className="btn btn-theemes">Change Password</button>
        </div>
      </form>
    </div>
  );
}
